import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-900f9836"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pa-8"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Státusz", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Költséghely", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Felhasználó", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Kapcsolattartó", -1))
const _hoisted_6 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Létrehozva", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Módosítva", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Lemondási feltételek", -1))
const _hoisted_10 = { class: "text-body-2 text-medium-emphasis mt-1 cancellation-policy-text" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Összesen:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
    : ($setup.error)
      ? (_openBlock(), _createBlock($setup["ResourceErrorState"], {
          key: 1,
          kind: $setup.error.kind,
          "cost-center": $setup.error.costCenter,
          "cost-center-name": $setup.error.costCenterName,
          "trace-id": $setup.error.traceId,
          "back-to": "/bookings",
          "back-label": "Vissza a foglalásokhoz",
          onRetry: $setup.fetchData
        }, null, 8, ["kind", "cost-center", "cost-center-name", "trace-id"]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 2,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, {
                  textContent: _toDisplayString(`Foglalás #${$setup.formatPublicReference($setup.booking.publicReference)}`)
                }, null, 8, ["textContent"]),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      class: "flex-nowrap",
                      "no-gutters": "",
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "mr-6" }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_chip, {
                                color: $setup.statusUi($setup.booking.status).color,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.statusUi($setup.booking.status).label), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createElementVNode("div", null, _toDisplayString($setup.booking.costCenterName), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createElementVNode("div", null, _toDisplayString($setup.booking.userName), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _createElementVNode("div", null, _toDisplayString($setup.booking.contactName || '-'), 1),
                            ($setup.booking.contactPhone)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.booking.contactPhone), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "mr-6" }, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _createElementVNode("div", null, _toDisplayString($setup.formatDateTime($setup.booking.createdAt)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createElementVNode("div", null, _toDisplayString($setup.formatDateTime($setup.booking.updatedAt)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    ($setup.booking.cancellationPolicy)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider, { class: "mb-3" }),
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, _toDisplayString($setup.booking.cancellationPolicy), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Foglalás elemei")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_data_table, {
                          headers: $setup.itemHeaders,
                          items: $setup.booking.items,
                          "item-key": "id"
                        }, {
                          "item.accommodation": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", null, _toDisplayString(item.accommodation), 1),
                              ($setup.formatLocation(item.city, item.address))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.formatLocation(item.city, item.address)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          "item.product": _withCtx(({ value }) => [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(value), 1)
                          ]),
                          "item.startDate": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.startDate), 1)
                          ]),
                          "item.endDate": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(item.endDate), 1)
                          ]),
                          "item.retailPrice": _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString($setup.formatPrice(value)), 1)
                          ]),
                          "item.outgoingGrossPerPersonPerNight": _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString($setup.formatPrice(value)), 1)
                          ]),
                          _: 1
                        }, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode($setup["CustomerBookingVersionHistory"], { versions: $setup.bookingVersions }, null, 8, ["versions"]),
            _createVNode(_component_v_row, { justify: "space-between" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["BusinessProcessActivityTimeline"], {
                      ref: "timeline",
                      "public-reference": $setup.booking.publicReference
                    }, null, 8, ["public-reference"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "elevation-2 mt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "text-h6" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Összesítés")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  class: "text-start",
                                  cols: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_16
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  class: "text-end",
                                  cols: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString($setup.formatPrice($setup.totalOutgoingPrice)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}